module.exports = __webpack_public_path__ + "media/images/icons/ic-pin-mini-309f34e19d230759de08298f4abc7076.svg";